import { render, staticRenderFns } from "./ProjectExportBox.vue?vue&type=template&id=405455f2&scoped=true"
import script from "./ProjectExportBox.vue?vue&type=script&lang=ts"
export * from "./ProjectExportBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405455f2",
  null
  
)

export default component.exports